/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { Login } from "../models/index";
import { LoginFromJSON, LoginToJSON } from "../models/index";

export interface SendLoginLinkCreateRequest {
  login: Login;
}

/**
 *
 */
export class SendLoginLinkApi extends runtime.BaseAPI {
  /**
   */
  async sendLoginLinkCreateRaw(
    requestParameters: SendLoginLinkCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["login"] == null) {
      throw new runtime.RequiredError(
        "login",
        'Required parameter "login" was null or undefined when calling sendLoginLinkCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/send-login-link/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LoginToJSON(requestParameters["login"]),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sendLoginLinkCreate(
    requestParameters: SendLoginLinkCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.sendLoginLinkCreateRaw(requestParameters, initOverrides);
  }
}
